module.exports = __webpack_public_path__ + "static/66-7416e445b6700808a584ec439dae7604.png";